import React from "react";
import { useTranslation } from "react-i18next";
import { LabelColumn, Row, ValueColumn } from "src/components/shared/Sidebar/SidebarTable";
import { EMPTY_VALUE_DASH } from "src/constants";
import { localizeCurrencyToWholeNumber } from "src/utils";

interface Props {
    tradeInEstimate: number;
}

const TradeInEstimate = ({ tradeInEstimate }: Props) => {
    const { t } = useTranslation();

    return (
        <Row>
            <LabelColumn>{t("ContinueDeal.VehicleInfo.tradeInLabel")}</LabelColumn>
            <ValueColumn>
                {tradeInEstimate ? localizeCurrencyToWholeNumber(tradeInEstimate) : EMPTY_VALUE_DASH}
            </ValueColumn>
        </Row>
    );
};

export default TradeInEstimate;
